import React from 'react';
import '../Filters/Filters.scss';
import DateFilter from './DateFilter';
import DateRangeFilter from './DateRangeFilter';
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";
import SingleSelectFilter from './SingleSelectFilter';
import { DATE_FILTER_CONDITIONS } from '../../constants/constants';
import SliderFilter from './SliderFilter';
import RelativeDateFilter from './RelativeDateFilter';

const CustomFilterPopover = ({
    popoverLabel,
    setShowFieldPopover,
    setExpandedFieldKey,
    expandedFieldKey,
    filteredFilterFields = [],
    repoFilters,
    filtersConditions,
    onRepoFilterChange,
    setFiltersConditions,
    onBlur
}) => {

    const toggleExpandField = (fieldKey) => {
        const next = expandedFieldKey === fieldKey ? null : fieldKey;
        setExpandedFieldKey(next);
    };

    const handleDateFilterValueReset = (value, fieldName) => {

        if (value === 'range') {
            onRepoFilterChange?.(
                fieldName,
                null
            );
            onRepoFilterChange?.(
                `${fieldName}RelDateVal`,
                null
            );

        }

        if (value === 'gte' || value === 'lte') {
            onRepoFilterChange?.(
                `${fieldName}Start`,
                null
            );
            onRepoFilterChange?.(
                `${fieldName}End`,
                null);
            onRepoFilterChange?.(
                `${fieldName}RelDateVal`,
                null
            );
        }

        if (value === 'withIn') {
            onRepoFilterChange?.(
                `${fieldName}Start`,
                null
            );
            onRepoFilterChange?.(
                `${fieldName}End`,
                null);
            onRepoFilterChange?.(
                fieldName,
                null
            );
        }
    }

    return (
        <div className="filters-popover">
            <div className="filters-popover-header">
                <span>{popoverLabel || 'Filters'}</span>
                <button
                    type="button"
                    className="filters-popover-close"
                    onClick={() => {
                        setShowFieldPopover?.(false);
                        setExpandedFieldKey?.(null);
                    }}
                >
                    ×
                </button>
            </div>

            <ul className="filters-popover-list">
                {filteredFilterFields.map((field) => {
                    const isExpanded = expandedFieldKey === field.fieldName;
                    return (
                        <li key={field.fieldName} className="filters-popover-row">
                            <button
                                type="button"
                                className="filters-popover-item"
                                onClick={() => toggleExpandField(field.fieldName)}
                            >
                                <span>{field.label}</span>
                                <span className="filters-popover-chevron">
                                    {isExpanded ? <MdKeyboardArrowDown className='filters-popover-close' /> : <MdKeyboardArrowRight className='filters-popover-close' />}
                                </span>
                            </button>

                            {isExpanded && (
                                <div className="filters-popover-expanded">
                                    {/* Pick first repo that supports this field as the source of current value */}
                                    {(() => {

                                        if (field.type === 'DATE') {
                                            const isRangeField = (field.allowLowRange || field.allowHighRange) && filtersConditions?.[field.fieldName]?.value === 'range';
                                            const startDate = repoFilters?.[`${field.fieldName}Start`] || null;
                                            const endDate = repoFilters?.[`${field.fieldName}End`] || null;


                                            return (
                                                <>
                                                    <div style={{ marginBottom: '8px' }}>
                                                        <SingleSelectFilter
                                                            value={filtersConditions[field.fieldName]}
                                                            label={`${field.label} Condition`}
                                                            options={DATE_FILTER_CONDITIONS}
                                                            isClearable={false}
                                                            onChange={(value) => {
                                                                const newValue = value?.value;
                                                                const oldValue = filtersConditions?.[field.fieldName]?.value;
                                                                const shouldResetInput = oldValue !== newValue;

                                                                if (shouldResetInput) {
                                                                    handleDateFilterValueReset(value?.value, field.fieldName);
                                                                }
                                                                
                                                                // Use the new handleConditionChange function if available
                                                                if (typeof setFiltersConditions === 'function' && setFiltersConditions.name !== 'bound dispatchAction') {
                                                                    setFiltersConditions(field.fieldName, value);
                                                                } else {
                                                                    // Fallback to original behavior
                                                                    setFiltersConditions?.((prev) => ({
                                                                        ...prev,
                                                                        [field.fieldName]: value,
                                                                    }));
                                                                }
                                                            }}
                                                            placeholderText={`Select ${field.label} Condition`}
                                                        />
                                                    </div>

                                                    {filtersConditions?.[field.fieldName]?.value !== 'withIn' && (
                                                        <>
                                                            {isRangeField ? <DateRangeFilter
                                                                key={field.fieldName}
                                                                label={' '}
                                                                sName={`${field.fieldName}Start`}
                                                                eName={`${field.fieldName}End`}
                                                                startDate={startDate ? startDate : null}
                                                                endDate={endDate ? endDate : null}
                                                                onChange={(dateRange) => {
                                                                    onRepoFilterChange?.(
                                                                        `${field.fieldName}Start`,
                                                                        dateRange.startDate
                                                                    );
                                                                    onRepoFilterChange?.(
                                                                        `${field.fieldName}End`,
                                                                        dateRange.endDate
                                                                    );
                                                                }}
                                                                minDate={field.minValue}
                                                                maxDate={field.maxValue}
                                                                allowLowRange={field.allowLowRange}
                                                                allowHighRange={field.allowHighRange}
                                                                onBlur={onBlur}
                                                            /> :
                                                                <DateFilter
                                                                    key={field.fieldName}
                                                                    label={' '}
                                                                    name={field.fieldName}
                                                                    selected={repoFilters?.[field.fieldName]}
                                                                    onChange={(date) => {
                                                                        onRepoFilterChange?.(
                                                                            field?.fieldName,
                                                                            date
                                                                        );

                                                                    }}
                                                                    placeholderText="Select date"
                                                                    onBlur={onBlur}
                                                                />
                                                            }
                                                        </>
                                                    )}

                                                    {filtersConditions?.[field.fieldName]?.value === 'withIn' && (
                                                        <RelativeDateFilter
                                                            field={field}
                                                            onChange={onRepoFilterChange}
                                                            repoFilters={repoFilters}
                                                            onBlur={onBlur}
                                                            name={`${field.fieldName}RelDateVal`}
                                                            setFiltersConditions={setFiltersConditions}
                                                            filtersConditions={filtersConditions}
                                                        />
                                                    )}
                                                </>
                                            );
                                        }

                                        if (field.type === 'STRING') {
                                            if (field?.validValues.length) {
                                                return (
                                                    <SingleSelectFilter
                                                        value={repoFilters?.[field.fieldName]}
                                                        options={field.validValues}
                                                        isClearable={true}
                                                        onChange={(value) => {
                                                            onRepoFilterChange?.(
                                                                field?.fieldName,
                                                                value
                                                            );
                                                        }}
                                                        placeholderText={`Select ${field.label}`}
                                                    />
                                                );
                                            }
                                        }

                                        if (field.type === 'NUMBER') {
                                            return (
                                                <SliderFilter
                                                    value={repoFilters?.[field.fieldName]}
                                                    min={field?.minValue}
                                                    max={field?.maxValue}
                                                    step={field?.steps || 1}
                                                    onChange={(value) => {
                                                        onRepoFilterChange?.(
                                                            field?.fieldName,
                                                            value
                                                        );
                                                    }}
                                                    onBlur={onBlur}
                                                />
                                            );
                                        }
                                        return null;
                                    })()}
                                </div>
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    )
}

export default CustomFilterPopover